import React, { Component } from 'react';
import tinymce from 'tinymce/tinymce';
import Grid from '@material-ui/core/Grid';

// A theme is also required
import 'tinymce/themes/modern/theme';
import { Editor } from '@tinymce/tinymce-react';
import 'tinymce/plugins/legacyoutput';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/noneditable';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/nonbreaking'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/textcolor'

//import 'tinymce/plugins/pagebreak'


export default class RichTextEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            html: '',
            htmlError: ''
        };
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevState.html === '') {
            tinymce.activeEditor.readonly = this.props.isReadOnly;
            tinymce.activeEditor.undoManager.clear();
            tinymce.activeEditor.undoManager.add();
        }
    }

    handleEditorChange = (html) => {
        this.setState({ html });
        this.props.onEditorChange(html);
    }


    render() {
        const toolBarOptions = `undo redo | bold italic | forecolor backcolor | alignleft aligncenter alignright | numlist bullist | code | cutomOutdentButton indent ${this.props.showFontControls == true ? '| fontselect | fontsizeselect' : ''}`;
        return (
            <Grid container spacing={2} >
                <Grid item xs={12}>
                    <Editor
                        value={this.props.reportData}
                        onEditorChange={this.handleEditorChange}
                        init={{
                            toolbar: toolBarOptions,
                            branding: false,
                            // Do not add editing guides to tables that are borderless in the source.
                            visual: false,
                            font_formats: 'Arial=arial,helvetica,sans-serif;Calibri=calibri,sans-serif;Courier New=courier new,courier,monospace;Times New Roman=times new roman,times,serif;',
                            skin_url: '/lib/skins/lightgray',
                            forced_root_block: false,
                            browser_spellcheck: true,
                            plugins: ' autoresize,noneditable,paste,nonbreaking,lists,advlist,textcolor',
                            fontsize_formats: '10pt 12pt 14pt',
                            content_style: "input { border: none; background-color: lightgray; width:auto} .page-break{border-top: dotted 1px;}",
                            removed_menuitems: 'newdocument',
                            nonbreaking_force_tab: true,
                            paste_data_images: true,
                            content_style: "body { overflow-y: auto !important; font-family: 'Font Family'; font-size: 12pt;}",
                            content_style: "img { margin: 0px !important;}",
                            setup: function (editor) {
                                editor.addButton('cutomOutdentButton', {
                                    tooltip: 'Decrease Indent',
                                    icon: 'outdent',
                                    onclick: function (e) {
                                        const indentListElement = function (element) {
                                            const olEL = document.createElement('ol');
                                            olEL.innerHTML = element.innerHTML;
                                            element.style.margin = '15px';
                                            element.style.padding = '0';
                                        };
                                        const selectedNode = editor.selection.getNode();
                                        const selectedEl = selectedNode;
                                        const parentEl = selectedNode.parentNode;
                                        switch (true) {
                                            case parentEl === 'UL':
                                                indentListElement(parentEl);
                                                break;
                                            case selectedEl.tagName === 'UL' || selectedEl.tagName === 'LI':
                                                indentListElement(selectedEl);
                                                break;
                                            default:
                                                editor.execCommand('Outdent');
                                                break;
                                        }
                                    }
                                });

                                editor.on('ExecCommand', function (e) {
                                    // A flag to prevent recursive execution
                                    if (editor._execCommandRecursive) {
                                        return;
                                    }

                                    const isEditable = (el) => {
                                        while (el) {
                                            if (editor.dom.hasClass(el, 'mceNonEditable')) {
                                                return false;
                                            }
                                            el = el.parentNode;
                                        }
                                        return true;
                                    };

                                    switch (e.command) {
                                        case 'FontName':
                                            let fontName = editor.queryCommandValue('FontName');
                                            editor._execCommandRecursive = true;  // Set flag to true
                                            editor.execCommand('SelectAll', false, null);
                                            editor.execCommand('FontName', false, fontName, false);
                                            editor.selection.collapse(false);
                                            editor._execCommandRecursive = false;  // Reset flag to false
                                            // After setting the font for the entire content:
                                            const allFontElements = editor.dom.select('span,font').filter(isEditable);
                                            allFontElements.forEach(el => {
                                                el.style.fontFamily = fontName;
                                                editor.dom.setAttrib(el, 'style', el.style.cssText);
                                                editor.dom.setStyle(editor.getBody(), 'font-family', fontName);
                                                el.removeAttribute('face');  // removes legacy <font face> attribute
                                            });
                                            break;

                                        case 'FontSize':
                                            let fontSize = editor.queryCommandValue('FontSize');
                                            editor._execCommandRecursive = true;  // Set flag to true
                                            editor.execCommand('SelectAll', false, null);
                                            editor.execCommand('FontSize', false, fontSize, false);
                                            editor.selection.collapse(false);
                                            editor._execCommandRecursive = false;  // Reset flag to false
                                            // After setting the font size for the entire content:
                                            const allSizeElements = editor.dom.select('span,font').filter(isEditable);
                                            allSizeElements.forEach(el => {
                                                el.style.fontSize = fontSize;
                                                editor.dom.setAttrib(el, 'style', el.style.cssText);
                                                editor.dom.setStyle(editor.getBody(), 'font-size', fontSize);
                                                el.removeAttribute('size');  // removes legacy <font size> attribute
                                            });
                                            break;
                                    }
                                });
                            }
                        }}

                    />
                </Grid>
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/RichTextEditor.js